import {Insurer} from '../insurer';
import {Dropdown} from './dropdown';

const INSURER_OPTIONS_FR: Dropdown<Insurer>[] = [
  {name: 'Empire', value: Insurer.EMPIRE},
  {name: 'UV', value: Insurer.UV},
  {name: 'Humania', value: Insurer.HUMANIA},
  {name: 'Beneva', value: Insurer.BENEVA},
  {name: 'CPP', value: Insurer.CPP},
  {name: 'IA', value: Insurer.IA},
  {name: 'Manuvie', value: Insurer.MANULIFE},
  {name: 'Sun Life', value: Insurer.SUN_LIFE},
  {name: 'Ivari', value: Insurer.IVARI},
  {name: 'BMO Assurance', value: Insurer.BMO},
  {name: 'Assomption-Vie', value: Insurer.ASSUMPTION},
  {name: 'Croix bleu', value: Insurer.BLUE_CROSS},
  {name: 'Canada Vie', value: Insurer.CANADA_LIFE},
  {name: "L'Excellence", value: Insurer.EXCELLENCE},
  {name: 'SLI', value: Insurer.SLI},
  {name: 'Financière Foresters', value: Insurer.FORESTERS},
  {name: 'RBC', value: Insurer.RBC},
  {name: 'Inconnu', value: Insurer.UNKNOWN},
];

const INSURER_OPTIONS_EN: Dropdown<Insurer>[] = [
  {name: 'Empire', value: Insurer.EMPIRE},
  {name: 'UV', value: Insurer.UV},
  {name: 'Humania', value: Insurer.HUMANIA},
  {name: 'Beneva', value: Insurer.BENEVA},
  {name: 'CPP', value: Insurer.CPP},
  {name: 'IA', value: Insurer.IA},
  {name: 'Manulife', value: Insurer.MANULIFE},
  {name: 'Sun Life', value: Insurer.SUN_LIFE},
  {name: 'Ivari', value: Insurer.IVARI},
  {name: 'BMO Insurance', value: Insurer.BMO},
  {name: 'Assumption Life', value: Insurer.ASSUMPTION},
  {name: 'Blue Cross', value: Insurer.BLUE_CROSS},
  {name: 'Canada Life', value: Insurer.CANADA_LIFE},
  {name: 'Excellence', value: Insurer.EXCELLENCE},
  {name: 'SLI', value: Insurer.SLI},
  {name: 'Foresters Financial', value: Insurer.FORESTERS},
  {name: 'RBC', value: Insurer.RBC},
  {name: 'Unknown', value: Insurer.UNKNOWN},
];

export const INSURER_OPTIONS = {
  en: INSURER_OPTIONS_EN,
  fr: INSURER_OPTIONS_FR,
};
